import api from './api';

export const getConsentForms = async () => {
  try {
    const response = await api.get('/consent-forms');
    const data = Array.isArray(response.data) ? response.data : (response.data?.data || []);
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.error || error.message || 'Failed to fetch consent forms',
      data: [],
    };
  }
};

